// import { Link } from 'react-router-dom';
// import './NotAuthenticated.scss';

import Button from "../Button/Button";

export default function GenericPage({ title, message, backbutton }) {
    return (
        <div id="generic-page">
            <div className="centered-container">
                <br />
                <h1>{title}</h1>
                <br />
                <p>{message}</p>
                <br />
                {backbutton === "true" ? (
                    <Button
                        text="Go Back"
                        onClick={() => {
                            window.history.back();
                        }}
                    />
                ) : (
                    null
                )}
                <br />
            </div>
        </div>
    );
}